import type { LocalizationDictionary } from "@slot/game-shell";

// Info-page text is split across two dictionaries:
//   - shell.<locale>.json     the shell's own words (its controls, modals and the info page's
//                             shared sections), shipped and loaded by the shell (decision 40).
//   - game.<locale>.json      this title's, in `assets-src/game-shared-visuals/localization/`,
//                             merged over the shell's: its features, its gamble panel, its info
//                             bodies (RTP value, volatility rating, paytable mechanics, free-spin
//                             counts, feature-purchase descriptions) and the info headings only
//                             its template needs.
//
// The HTML template at `assets-src/game-shared-visuals/info/html/template.html`
// is shared across locales and references both via `{info.<path>}` tokens.
// This TS file is the synchronous boot-time fallback for game-specific
// strings; info-page keys load from the JSON files before the info panel
// is reachable.

export const gameEnDictionary: LocalizationDictionary = {

  // features

  "featurefinished.offer.title": "Buy extra free spins?",
  "featurefinished.subtitle": "in Free Spins",

  "featuretrigger.title": "You Have Won",
  "featuretrigger.subtitle": "Free Spins",


  // the win meter's tips, while it has no total

  "tips.tumble": "Tip: Wins burst and new symbols tumble in",
  "tips.cannon": "Tip: Every winning tumble fires the cannon",
  "tips.chance": "Tip: No win? A barrel blasts its neighbours",
  "tips.free_spins": "Tip: Land scatters to trigger free spins",

  "feature_purchase.super_bonus_buy.title": "Bonus Buy",
  "feature_purchase.super_bonus_buy.description": "Buy your way straight into the free-spins round.",
  "feature_purchase.bonus_hunt_mode.title": "Bonus Hunt",
  "feature_purchase.bonus_hunt_mode.description": "Each spin is more likely to trigger free spins.",

  // gamble

  "gamble.option.red": "Red",
  "gamble.option.black": "Black",
  "gamble.label.your_win": "Your Win",
  "gamble.label.gamble_to_win": "Gamble To Win",
  "gamble.action.collect": "Collect",
  "gamble.result.won": "You Won",
  "gamble.result.loose": "You Lost",
  "gamble.attempts_remaining": "{count} attempts remaining",

  // info-page headings only this title's template reads (the shell's until decision 40)

  "info.specialSymbols.title": "SPECIAL SYMBOLS",
  "info.specialSymbols.body": "These symbols are not on the paytable and do not pay on their own.",
  "info.specialSymbols.wild.title": "WILD",
  "info.specialSymbols.scatter.title": "SCATTER",
  "info.specialSymbols.chance.title": "CHANCE",
  "info.tumbles.title": "TUMBLES",
  "info.cannon.title": "THE CANNON",
  "info.freeSpinsTrigger.title": "FREE SPINS TRIGGER",
  "info.freeSpins.title": "FREE SPINS",
  "info.quickStop.title": "QUICK STOP",
  "info.featurePurchase.intro": "Where available, you can buy free spins or play with a higher chance to trigger them:",
};
